import React, { useLayoutEffect } from 'react'
import Eventsdata from '../Data/Eventsdata';
import { useLocation } from "react-router-dom";
import banner from '../Images/abouttwo.jpg'
import '../Css/Events.css'
import Footer from '../Component/Footer/Footer';
import { MetaTags } from 'react-meta-tags';
import { Slide, Zoom } from 'react-awesome-reveal';

const Events = () => {
    const path = useLocation()
    const search = path.pathname;
    useLayoutEffect(() => {
      window.scrollTo(0, 0)
  });
    {Eventsdata.filter(data=> data.slugs===search).map((data,i) => {
          
      document.title=`${data.title}`;
      document.querySelector("meta[name='description']").setAttribute("content",
        `${data.desc}`
      )
      
   
    
  })};
  return (
    <>
    {Eventsdata.filter((data)=>data.slugs===search).map((data)=>(
     <>   
     <MetaTags>
                             <title>{data.title}</title>
                             <meta title={data.title} />
                             <meta name="description" content={data.desc} />
                             <meta name="keywords" content="Best Resort in Mahabaleshwar, Top Resort with Rooms in Mahabaleshwar, Resort with Valley View in Mahabaleshwar, Resort with Premium Rooms in Mahabaleshwar, Best 3BHK Villa in Mahabaleshwar, Premium Villa in Mahabaleshwar, Family Resort in Mahabaleshwar, Resort near Mahabaleshwar" />
                             <link rel="canonical" href={`https://seemasresort.com/${data.slugs}`} />
                             <meta http-equiv="cache-control" content="no-cache" />
                             <meta http-equiv="expires" content="0" />
                             <meta http-equiv="pragma" content="no-cache" />
                             <meta property="og:title" content={data.title} />
                             <meta property="og:locale" content="en_US" />
                             <meta property="og:type" content="website" />
                             <meta property="og:url" content="https://seemasresort.com/" />
                             <meta property="og:description" content={data.desc} />
                             <meta property="og:image" content="https://seemasresort.com/static/media/logo.png" />
                           </MetaTags>
    <section className=' About-Page-Section-Banner-Images'  style={{
    backgroundImage:`linear-gradient(90deg, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)), url(${banner})`
    ,backgroundSize:'cover',
    // height:'350px',objectFit:'cover'
    }}>
        <div className='About-Page-Section-Banner-Images-con'>
          <h2 className='mt-5 ms-5' style={{color:'white'}}>{data.name}</h2>
        </div>
      </section>
      <div className="container mt-4 my-2 ">
<h1 className="text-start heading" style={{fontFamily:" var(---lato)"}}>{data.head}</h1>
</div>
      <section className='About-Page-Section-Details-First-con'>
        <div className='container mt-5'>
          <div className='row'>
            <div className='col-md-5'>
              <Zoom direction='out'>
              <div className='About-Page-Section-First-image-con'>
              <img src={data.img[0]} style={{width:'100%',height:'350px',objectFit:'cover',borderRadius:'16px'}} alt='img'/>
              </div>
              </Zoom>
            </div>
            <div className='col-md-7 d-flex align-items-center '>
              <Slide direction='right'>
              <div className='About-Page-Section-First-Details-con'>
                {/* <h3>Luxury Best Resort</h3> */}
                <h5 className='mt-3' style={{color:'var(---primaryColor)'}}>
                {/* {data.contenttwo[1]} */}
                </h5>
                <p style={{textAlign:'justify'}}>
               {data.contentone[0]}
                </p>
                
              </div>
              </Slide>
            </div>
          </div>
        </div>
      </section>




      <section className='py-5 About-Page-Section-Details-First-con mt-5' style={{backgroundColor:"#254222",color:"#ece2b1"}}>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 d-flex align-items-center'>
              <Slide>
              <div className='About-Page-Section-First-Details-con'>
                {/* <h3>Luxury Best Resort</h3> */}
                <h5 className='mt-3'  style={{color:'var(---primaryColor)'}}>
                {/* {data.contenttwo[1]} */}
                </h5>
                <p style={{textAlign:'justify'}}>
                {data.contentone[1]}
                </p>
                
              </div>
              </Slide>
            </div>
            <div className='col-md-5'>
              <Zoom direction='out'>
              <div className='About-Page-Section-First-image-con'>
              <img src={data.img[1]} style={{width:'100%',height:'350px',objectFit:'cover',borderRadius:'16px'}} alt='img'/>
              </div>
              </Zoom>
            </div>
          </div>
        </div>
      </section>





      <section className='my-5 About-Page-Section-Details-First-con'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-5'>
              <Zoom direction='out'>
              <div className='About-Page-Section-First-image-con'>
                <img src={data.img[2]} style={{width:'100%',height:'350px',objectFit:'cover',borderRadius:'16px'}} alt='img'/>
              </div>
              </Zoom>
            </div>
            <div className='col-md-7 d-flex align-items-center'>
              <Slide direction='right'>
              <div className='About-Page-Section-First-Details-con'>
                {/* <h3>Luxury Best Resort</h3> */}
                <h5 className='mt-3'  style={{color:'var(---primaryColor)'}}>
                {/* {data.contenttwo[2]} */}
                </h5>
                <p style={{textAlign:'justify'}}>
                {data.contentone[2]}
                </p>
                
              </div>
              </Slide>
            </div>
          </div>
        </div>
      </section>
    </>
))}
      <Footer/>
    </>
  )
}

export default Events
